/**
 * 轮播
 * @Author:   fjj
 *
 * Copyright 20121-2022, all rights reserved. Essa.cn
 */
import React from 'react';
import {Empty,} from 'antd';
import "./Index.less"

export default class ImageSlider extends React.Component {
    static defaultProps = {
        list: [],
    };
    constructor(props) {
        super(props);
        this.state = {
            iCurrent: 0,
            timerBanner: null,
            AnimationTime: 1000*6,
            pushInx:{}
        }
    }
    // 上一张
    prev(iCurrent) {
        const { list }  = this.props;
        const newInx = iCurrent-1 >= 0?iCurrent-1: list.length-1;
        this.setState({
            iCurrent: newInx
        })
    }
    changeBanner(index){
        this.setState({
            iCurrent:index
        })
    }
    // 下一张
    next(iCurrent) {
        const { list }  = this.props;
        const newInx =iCurrent+1 < list.length ? iCurrent+1: 0;
        this.setState({
            iCurrent: newInx
        })
    }
    componentDidMount() {
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { list, } = this.props;
        const { iCurrent } = this.state;
        return ( list.length>0?<div className="banner-scroll" >
                <div className="scroll_box" >
                   <img src={list[iCurrent].fileUrl}  />
                </div>
                {/*// 指示条*/}
                <div className='scroll_dots'>
                    {list.map((item,index)=>(
                        <div key={index} className={'scroll_dots_item'+(iCurrent==index?" dots_active":"")} onClick={()=>this.changeBanner(index)}>
                            <img src={item.fileUrl} alt={item.title} />
                        </div>)
                    )}
                </div>
                {/* 切换按钮*/}
                <div className='scroll_option scroll_option_left' onClick={()=>this.prev(iCurrent)}><i
                    className="ri-arrow-left-s-line"></i> </div>
                <div className='scroll_option scroll_option_right' onClick={()=>this.next(iCurrent)}><i
                    className="ri-arrow-right-s-line"></i></div>
            </div>:<div className="banner-scroll" >
                <div className="scroll_box" >
                    <Empty className={'empty_img'} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>
            </div>)
    }
}
